import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowDown, Phone, Search, Infinity, Globe2, Sparkles } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';

const channelIcons = [Search, Infinity, Phone, Sparkles, Globe2];

export const GrowthHero = ({ copy }) => {
  const reduced = useReducedMotion();
  return <>
    <section className="growth-hero" data-testid="home-hero">
      <img className="growth-hero-image" src="/images/lawyah-growth-office.jpg" alt="" fetchPriority="high" />
      <div className="growth-hero-shade" />
      <div className="site-container growth-hero-content">
        <motion.div initial={reduced ? false : { opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .6 }}>
          <p className="growth-hero-eyebrow" data-testid="home-ai-badge"><span />{copy.eyebrow}</p>
          <div className="growth-product-name" data-testid="hero-product-name">Lawyah.</div>
          <h1 data-testid="home-title">{copy.headline}<br /><em>{copy.headlineAccent}</em></h1>
          <p className="growth-hero-description" data-testid="home-growth-promise">{copy.description}</p>
          <div className="growth-hero-actions"><Link to="/book-demo" className="cta-primary" data-testid="hero-book-demo">{copy.cta}<ArrowUpRight size={17} /></Link><a href="#try-lawyah" className="growth-voice-link" data-testid="hero-try-lawyah"><span className="growth-phone-icon"><Phone size={16} /></span>{copy.voiceCta}</a></div>
          <p className="growth-hero-note" data-testid="hero-demo-agenda-note">{copy.heroNote}</p>
        </motion.div>
        <div className="growth-hero-bottom"><span data-testid="home-model-label">POWERED BY GPT-6 ASTRA</span><a href="#growth-picture" aria-label={copy.flowEyebrow} data-testid="hero-scroll"><ArrowDown size={18} /></a></div>
      </div>
      <span className="growth-hero-side" aria-hidden="true">{copy.heroSide}</span>
    </section>
    <section className="growth-channels" data-testid="growth-channels"><div className="site-container">
      <p>{copy.channelIntro}</p><div className="growth-channel-list">{copy.channels.map((name, index) => { const Icon = channelIcons[index]; return <span key={name} data-testid={`growth-channel-${index}`}><Icon size={22} strokeWidth={1.5} />{name}</span>; })}</div>
      <small data-testid="growth-channel-availability">{copy.channelNote}</small>
    </div></section>
  </>;
};